<a *ngIf="title" id="{{idTooltip}}" class="tooltip {{type}}" [attr.message]=title [ngClass]="title ? 'tooltip-message' : ''" >
  <img [src]="srcIcon" alt="icon">
</a>
<a *ngIf="image" id="{{idTooltip}}" class="tooltip {{type}} {{image}}">
  <img [src]="srcIcon" alt="icon">
</a>